import { formatDate, parseDate, utcOffset } from 'rise-ui/utils/date.js';

const qp = {
  version: 'v',
  memory: 'mem',
  filter: 'filter',
  search: 'search',
  order: 'order',
  page: 'page',
  locations: 'lo',
  items: 'it',
  modelRuns: 'mr',
  defaultDates: 'dd',
  itemDates: 'id',
  modelRunDates: 'md',
  style: 'style',
};
export default qp;

export const minDate = '00000000';
export const maxDate = '99999999';

export const toQueryDate = date => {
  if (!date || date === minDate || date === maxDate) {
    return date || '';
  }
  date = date instanceof Date ? utcOffset(date) : parseDate(date, 'url');
  return date ? formatDate(date, 'url') : '';
};

export const toQueryDates = dates =>
  dates && [ toQueryDate(dates[0]), toQueryDate(dates[1]) ];

export const hashToQueryDates = hash => {
  const queryDates = {};
  Object.entries(hash).forEach(([ key, value ]) => {
    queryDates[key] = toQueryDates(value);
  });
  return queryDates;
};
